import { createFileRoute } from '@tanstack/react-router';
import { PeopleMergeRouteView } from '@/pages/workspaces/people/routing';
import { LastWorkspaceResolver } from './-components';
import { validateMergeSearch } from './-people-merge-search';

/**
 * No `appBundle`: this URL has no `journeys` segment, and the bundle-aware
 * branch of the resolver rebuilds the target from the bundle prefix — which
 * would find no `/journeys/` here and land on the Journeys home instead.
 *
 * Both People segments render the page; the route view forwards the one the
 * account's taxonomy stage does not serve.
 */
function PeopleMergeRoute() {
  return (
    <LastWorkspaceResolver>
      <PeopleMergeRouteView segment="people" />
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/people/merge')({
  component: PeopleMergeRoute,
  validateSearch: validateMergeSearch,
});
